import { FC, memo, useMemo } from 'react';
import { useCompanyBetaFeatures, useNetSuiteItemsFieldSettings } from 'shared/hooks';

import { useLineCustomFieldsDefinition } from '../../NetSuiteRequestCard.hooks';
import { NetSuiteLineTable } from '../NetSuiteLineTable/NetSuiteLineTable';
import { getColumnDefs } from './NetSuiteItemLines.config';
import { messages } from './NetSuiteItemLines.messages';
import { NetSuiteItemLinesProps } from './NetSuiteItemLines.types';

export const NetSuiteItemLines: FC<NetSuiteItemLinesProps> = memo((props) => {
    const { request, itemLines, companyCustomFields, documentFields, exchangeRate, readonly } = props;

    const fieldSettings = useNetSuiteItemsFieldSettings(documentFields);

    const customFieldsColumnDefinitions = useLineCustomFieldsDefinition(itemLines, companyCustomFields);

    const { isNetSuiteBillToPOMatching } = useCompanyBetaFeatures(request.companyId);

    const columnDefinitions = useMemo(
        () =>
            getColumnDefs({
                request,
                fieldSettings,
                customFieldsColumnDefinitions,
                exchangeRate,
                readonly,
                isNetSuiteBillToPOMatching,
            }),
        [request, fieldSettings, customFieldsColumnDefinitions, exchangeRate, readonly, isNetSuiteBillToPOMatching]
    );

    if (itemLines.length === 0) {
        return null;
    }

    return (
        <NetSuiteLineTable
            title={messages.sectionHeaderText}
            columnDefinitions={columnDefinitions}
            lineItems={itemLines}
        />
    );
});

NetSuiteItemLines.displayName = 'NetSuiteItemLines';
